import React from "react";

export default function Clickable({ onClick = () => null, style, className, children }) {
  return (
    <span onClick={onClick} style={{ cursor: "pointer", ...style }} className={className}>
      {children}
    </span>
  );
}
